const pubIDsObj = {
  "partner-pub-9718435370311023": {
    src: "https://fundingchoicesmessages.google.com/i/pub-9718435370311023?ers=1",
    nonce: "u4yh1DKvbtTMiD-NV9g6UA"
  },
  "partner-pub-3772462770383362": {
    src: "https://fundingchoicesmessages.google.com/i/pub-3772462770383362?ers=1",
    nonce: "SrFxqB5YhTXv9zxT3eg0_Q"
  },
  "partner-pub-3426987762009703": {
    src: "https://fundingchoicesmessages.google.com/i/pub-3426987762009703?ers=1",
    nonce: "_sB9OmeWhvjpN0KSHibA7A"
  },
  "partner-pub-2933500308486888": {
    src: "https://fundingchoicesmessages.google.com/i/pub-2933500308486888?ers=1",
    nonce: "G5OXwYkx4XGQjWNRZRcsTg=="
  },
  "partner-pub-2050903959253458": {
    src: "https://fundingchoicesmessages.google.com/i/pub-2050903959253458?ers=1",
    nonce: "mKei1qBjNf6R3BI3wU9pcw=="
  },
  "partner-pub-8415768722735715": {
    src: "https://fundingchoicesmessages.google.com/i/pub-8415768722735715?ers=1",
    nonce: "AakV90F473nSCyDSz8i+aw=="
  },
  "partner-pub-7671733567783864": {
    src: "https://fundingchoicesmessages.google.com/i/pub-7671733567783864?ers=1",
    nonce: "ZSZe2N1/rb2gTM/wQEL9yw=="
  }
};

const pubIDsRecoveryScripts = {
  "partner-pub-9718435370311023": {
    src: "https://fundingchoicesmessages.google.com/i/pub-9718435370311023?ers=1",
    nonce: "rE-WPIn1mc1g6PVHvojzwQ",
  },
  "partner-pub-3772462770383362": {
    src: "https://fundingchoicesmessages.google.com/i/pub-3772462770383362?ers=1",
    nonce: "jjpUbvD7BvbK2VG7x1nPUw",
  },
  "partner-pub-3426987762009703": {
    src: "https://fundingchoicesmessages.google.com/i/pub-3426987762009703?ers=1",
    nonce: "wfYuywjZcFyQIT4JBgqhdw",
  },
  "partner-pub-2933500308486888": {
    src: "https://fundingchoicesmessages.google.com/i/pub-2933500308486888?ers=1",
    nonce: "G5OXwYkx4XGQjWNRZRcsTg=="
  },
  "partner-pub-2050903959253458": {
    src: "https://fundingchoicesmessages.google.com/i/pub-2050903959253458?ers=1",
    nonce: "mKei1qBjNf6R3BI3wU9pcw=="
  },
  "partner-pub-8415768722735715": {
    src: "https://fundingchoicesmessages.google.com/i/pub-8415768722735715?ers=1",
    nonce: "AakV90F473nSCyDSz8i+aw=="
  },
  "partner-pub-7671733567783864": {
    src: "https://fundingchoicesmessages.google.com/i/pub-7671733567783864?ers=1",
    nonce: "ZSZe2N1/rb2gTM/wQEL9yw=="
  }
};

function getSignalGoogleFCScriptContent() {
  return `(function() {
    function signalGooglefcPresent() {
      if (!window.frames["googlefcPresent"]) {
        if (document.body) {
          const iframe = document.createElement("iframe");
          iframe.style = "width: 0; height: 0; border: none; z-index: -1000; left: -1000px; top: -1000px;";
          iframe.style.display = "none";
          iframe.name = "googlefcPresent";
          document.body.appendChild(iframe);
        } else {
          setTimeout(signalGooglefcPresent, 0);
        }
      }
    }
    signalGooglefcPresent();
  })();`;
}

export const adBlockingRecoveryScript = pubId => {
  if (!pubId || !pubIDsObj[pubId]) return;

  // Create and append the script for ad blocking recovery
  const script = document.createElement("script");
  script.src = pubIDsObj[pubId].src;
  script.nonce = pubIDsObj[pubId].nonce;
  document.head.appendChild(script);

  // Create and append the script to signal Google FC presence
  const signalScript = document.createElement("script");
  signalScript.textContent = getSignalGoogleFCScriptContent();
  document.head.appendChild(signalScript);
};

export const adRecoveryCodeAcrossDomains = pubId => {
  if (!pubId || !pubIDsRecoveryScripts[pubId]) return;

  // Create and append the script for ad blocking recovery
  const script = document.createElement("script");
  script.setAttribute('async', true);
  script.src = pubIDsRecoveryScripts[pubId].src;
  script.nonce = pubIDsRecoveryScripts[pubId].nonce;
  document.head.appendChild(script);

  const signalScript = document.createElement("script");
  signalScript.nonce = pubIDsRecoveryScripts[pubId].nonce;
  signalScript.textContent = getSignalGoogleFCScriptContent();
  document.head.appendChild(signalScript);
};
